import {
  Snackbar as MuiSnackbar,
  Alert,
  Typography,
  IconButton,
} from '@mui/material'
import { useSelector } from 'react-redux'
import { selectSnack } from '../../features/snack-bar/snackSlice'
import { SNACK_AUTOHIDE_TIMEOUT } from '../../constants'
import { useDispatch } from 'react-redux'
import { clearSnack } from '../../features/snack-bar/snackSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
  faWarning,
  faCircleCheck,
  faCircleInfo,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

function Snackbar() {
  const snack = useSelector(selectSnack)
  const dispatch = useDispatch()
  const open = snack.open
  const handleClose = () => dispatch(clearSnack())

  const iconMap = {
    error: <FontAwesomeIcon icon={faCircleExclamation} />,
    warning: <FontAwesomeIcon icon={faWarning} />,
    success: <FontAwesomeIcon icon={faCircleCheck} />,
    info: <FontAwesomeIcon icon={faCircleInfo} />,
  }
  
  return (
    <MuiSnackbar
      autoHideDuration={SNACK_AUTOHIDE_TIMEOUT}
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={snack.severity}
        elevation={6}
        variant="filled"
        iconMapping={iconMap}
      >
        <Typography variant="body1">{snack.message}</Typography>
        <IconButton size="small" onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark} size="1x" fixedWidth/>
        </IconButton>
      </Alert>
    </MuiSnackbar>
  )
}

export default Snackbar
